<template>
  <div class="class">
    <class-head :updateMark="updateMark" :tel="tel" @toolShow="toolShow"></class-head>
    <class-list
      @getListSuccess="getListSuccess"
      :lessonIndex="lessonIndex"
      :subjectIndex="subjectIndex"
      :gradeIndex="gradeIndex"
      :classYear="classYear"
      :semesterIndex="semesterIndex"
      :guideShow="guideShow"
    ></class-list>
    <div
      class="tool_mask"
      v-show="toolisShow"
      @click="toolisShow = false"
    ></div>
    <transition name="slide">
      <tool
        @checkLessonType="checkLessonType"
        @toolShow="toolShow"
        v-show="toolisShow"
        :classYears="classYears"
        :classGrades="classGrades"
        :subjects="subjects"
      ></tool>
    </transition>
    <update-version v-if="a_update" :datas="upDatas"></update-version>
    <announce v-if="b_announce" :datas="announceData"></announce>
    <badge-box v-if="c_badgeBox" :datas="badegeList"></badge-box>
    <icp />
  </div>
</template>

<script>
import class_head from './class_head';
import tool from './tool';
import class_list from './class_list';
import badge_box from '../badgeBox/badgebox';
import update_version from '../../basic/updateversion';
import announce from '../../basic/announce.vue';
import icp from '@/components/basic/icp.vue';
import common from 'common';
import { mapState, mapMutations, mapActions } from 'vuex';
if (LIMI_ENV === 'electron') {
  var ipc = window.require('electron').ipcRenderer;
}
export default {
  name: 'class',
  data() {
    return {
      updateMark: false, //小游戏入口红点
      // already_Guide: false,
      badegeList: [],
      classYears: [],
      classGrades: [],
      upDatas: {},
      announceData: {},
      a_update: false,
      b_announce: false,
      c_badgeBox: false,
      guideShow: false,
      checkWindow: {
        guideShow: 0,
        a_update: 0,
        b_announce: 0,
        c_badgeBox: 0,
      },
      subjectIndex: '',
      gradeIndex: '',
      lessonIndex: '',
      classYear: '',
      semesterIndex: '',
      toolisShow: false,
      subjects: [],
      tel: '',
    };
  },
  components: {
    'class-head': class_head,
    'class-list': class_list,
    'update-version': update_version,
    'badge-box': badge_box,
    announce,
    tool,
    icp,
  },
  watch: {
    checkWindow: {
      deep: true,
      handler(newV) {
        if (newV.guideShow == 0) return;
        if (newV.guideShow == 1) {
          this.showPopup();
        } else if (newV.a_update == 1) {
          this.showPopup();
        } else {
          if (newV.a_update == 0) {
          } else {
            let flag = true;
            for (let x in newV) {
              if (newV[x] == 0) {
                flag = false;
                break;
              }
            }
            if (flag) this.showPopup();
          }
        }
      },
    },
  },
  computed: {
    ...mapState(['userID', 'phone', 'firstLogin', 'lastGrade']),
  },
  created() {
    this.checkWindow.guideShow = this.firstLogin ? 0 : 2;
    this.$root.eventHub.$on('showPopup', (type) => {
      this[type] = false;
      switch (type) {
        case 'guideShow':
          this.guideShow = false;
          this.saveFirstLogin(2);
          break;
        case 'a_update':
          this.upDatas = {};
          break;
        case 'b_announce':
          this.announceData = {};
          break;
        case 'c_badgeBox':
          this.badegeList = [];
          break;
      }
      setTimeout(() => {
        this.checkWindow[type] = 3;
      }, 500);
    });
    // this.upDatas = {
    //   desc_image: null,
    //   description: "1.新增语音题\n2.新增打字交互\n3.新增语音题\n3.新增打字交互",
    //   frequency: "0",
    //   is_show: 1,
    //   md5: "461a7799261bf4be07a7e30274e7b945",
    //   package_type: "1",
    //   sub_description: "",
    //   sub_type: "2",
    //   type: "1",
    //   update: true,
    //   url: "https://limi-live-video.oss-cn-shanghai.aliyuncs.com/pkg/limi-2.5.8.exe",
    //   version: "2.5.8"
    // }
    // this.a_update = 1
  },
  mounted() {
    if (this.$route.params.from === 'first' && LIMI_ENV === 'electron') {
      //判断当前平台是否需要进行升级接口请求
      this.updateVersion();
    } else {
      this.checkWindow.a_update = 2;
      //非pc平台不需要进行接口查询，直接显示下一个窗口
    }
    this.getClassPageBaseData({
      data: {
        client: common.client,
        version: common.version,
        username: this.phone,
      },
    }).then(({ res, ok }) => {
      console.log('16==========',res)
      if (ok) {
        if (res.badge && res.badge.list && res.badge.list.length > 0) {
          this.badegeList = res.badge.list;
          this.checkWindow.c_badgeBox = 1;
        } else {
          this.checkWindow.c_badgeBox = 2;
        } //首页徽章展示
        this.tel = res.contactUs;
        const maps = common.get('gamelist') || {};
        let kejianGameList = res.courseWareGame.list[this.lastGrade];
        this.updateMark = kejianGameList.some((item) => {
          return item.version != maps[item.folder];
        });
        common.setSession('randerGameList', res.courseWareGame);
        if (res.noticeList && res.noticeList[0] && res.noticeList[0].id) {
          this.getNoticeInfo(res.noticeList[0]);
        } else {
          this.checkWindow.b_announce = 2;
        }
      } else {
        this.checkWindow.c_badgeBox = 2;
        this.checkWindow.b_announce = 2;
      }
    });
  },
  methods: {
    ...mapActions(['getClassPageBaseData', 'getLatestVersion']),
    ...mapMutations(['saveFirstLogin']),
    // closeGuide() {
    //   fs ? utils.setNodeStorge("already_Guide", true) : common.set("already_Guide", true);
    //   this.already_Guide = true;
    // },
    getListSuccess() {
      this.checkWindow.guideShow = 1;
    },
    getClassList(res) {
      let classYears = res
        .map((v) => (v.experienceSubType == 26 ? '' : v.classYear))
        .filter((v) => v != '');
      let classGrades = res
        .map((v) =>
          v.experienceSubType == 26 ? '' : v.grade == 32 ? 31 : v.grade,
        )
        .filter((v) => v != '');
      this.classGrades = [0].concat([...new Set(classGrades)]);
      const subs={}
      res.forEach((v) => {
        subs[v.subject] = v.subjectName;
      });
      this.subjects = ['全部科目'].concat(
        Object.values(subs)
      );
      this.classYears = ['全部年份'].concat(
        [...new Set(classYears)].sort((a, b) => a - b),
      );
    },
    checkLessonType(
      gradeIndex,
      lessonIndex,
      subjectIndex,
      classYear,
      semesterIndex,
    ) {
      //筛选班级列表

      this.gradeIndex = gradeIndex;
      this.lessonIndex = lessonIndex;
      this.subjectIndex = subjectIndex;
      this.classYear = classYear;
      this.semesterIndex = semesterIndex;
    },
    toolShow(show) {
      this.toolisShow = show;
    },
    showPopup() {
      for (let x in this.checkWindow) {
        if (this.checkWindow[x] == 1) {
          this[x] = true;
          break;
        }
      }
    },

    getNoticeInfo(data) {
      let getStorage;
      let setStorage;
      if (data.showType == '1') {
        //localStorage存储
        getStorage = 'get';
        setStorage = 'set';
      } else if (data.showType == '2') {
        //SessionStorage存储
        getStorage = 'getSession';
        setStorage = 'setSession';
      } else {
        console.error(`showType is Error : ${data.showType}`);
        this.checkWindow.b_announce = 2;
        return;
      }
      let announce_id = common[getStorage]('announce_id');
      if (announce_id != data.id) {
        common[setStorage]('announce_id', data.id);
        this.announceData = JSON.parse(JSON.stringify(data));
        this.checkWindow.b_announce = 1;
      } else {
        this.checkWindow.b_announce = 2;
      }
    },
    updateVersion() {
      let updateCancel = window.localStorage.getItem('updateCancel');
      this.getLatestVersion({
        platform: common.device,
        version: common.version,
        uid: this.userID,
      }).then(
        ({ res, ok }) => {
          if (!ok) {
            this.checkWindow.a_update = 2;
            return;
          }
          if (updateCancel) {
            window.localStorage.removeItem('updateCancel');
            this.checkWindow.a_update = 2;
            return;
          }
          if (res.update && LIMI_ENV === 'electron') {
            //需要显示升级窗口
            if (res.package_type == 1) {
              if (res.is_show == 1) {
                this.upDatas = res;
                this.checkWindow.a_update = 1;
              } else {
                this.checkWindow.a_update = 2;
              }
            } else {
              //补丁包
              if (res.type == 1) {
                ipc.send('restartApp');
              } else {
                this.checkWindow.a_update = 2;
              }
            }
          } else {
            //不需要显示升级窗口
            this.checkWindow.a_update = 2;
          }
        },
        () => {
          this.checkWindow.a_update = 2;
        },
      );
    },
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.class {
  width: 100%;
  height: 100%;
  // background: url('/static/img/class/bg.png') no-repeat;
  background: url('../../../assets/img/common/space.jpg') no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;
}
.tool_mask {
  position: absolute;
  z-index: 101;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.slide-enter-active {
  animation: slideLift 0.7s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.slide-leave-active {
  animation: slideLift 0.7s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/class/class.vue